import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';

// English ships in the main bundle; French and Arabic are separate chunks fetched only when chosen,
// so most visitors never download them. Until a chunk arrives, `fallbackLng` shows the English text.
const lazyLanguages = {
    type: 'backend',
    init() {},
    read(language, namespace, callback) {
        import(`./${language}.json`)
            .then(module => callback(null, module.default))
            .catch(error => callback(error, null));
    },
};

const savedLanguage = () => {
    try {
        return localStorage.getItem('lang');
    } catch {
        return null;
    }
};

i18n.use(lazyLanguages).use(initReactI18next).init({
    resources: { en: { translation: en } },
    partialBundledLanguages: true,
    lng: savedLanguage() || 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'ar'],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
});

export default i18n;
